import l10n from "diy/util/l10n";

import AlertWarningIcon from "material-ui/svg-icons/alert/warning";

import Type from "../definitions/Type";
import {NotificationConfig} from "../definitions/Config";

export default {
    type: Type.NOT_PUBLISHED,
    testId: "not-published",
    trackingId: "NotPublishedNotification",

    title: l10n("toolbar.maintenance.publish.notification.title"),
    content: l10n("toolbar.maintenance.publish.notification.description"),
    icon: AlertWarningIcon,

    mainAction: {
        testId: "open-guided-setup",
        label: l10n("notifications.moreDetails"),
        onClick: () => {
            diy.editor.deeplinking.requestPath([
                {label: 'siteadmin', params: 'guidedsetup'}
            ]);
        }
    },

    cardOptions: {
        closable: false
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/NotPublished.ts
 **/